import moment from "moment";
import "moment/locale/es";
import { cuentaMask } from "../Components/Items";
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";

moment.locale("es");

const reportePedidosPendientesApartarPdf = (values) => {
  const empresa = values.empresa;
  const logoBiwo = values.logoBiwo;
  let filtrados = [];

  if (values.clientes !== 0 && values.clientes && values.clientes.length > 0) {
    let textoFiltrado = "";
    values.clientes.forEach((valueCliente) => {
      textoFiltrado += `${(valueCliente.persona ? valueCliente.nombre : (valueCliente.nombre + " " + valueCliente.apellidoPaterno + " " + valueCliente.apellidoMaterno)) + valueCliente.razonSocial + " - " + valueCliente.rfc}\n`;
    });
    filtrados.push([{ text: "Clientes:", style: "subheader" }, { text: textoFiltrado, style: "textoChico" }]);
  }

  if (values.vendedores !== 0 && values.vendedores && values.vendedores.length > 0) {
    let textoFiltrado = "";
    values.vendedores.forEach((valueVendedor) => {
      textoFiltrado += `${valueVendedor.nombre + " " + valueVendedor.apellidoPaterno + " " + valueVendedor.apellidoMaterno}\n`;
    });
    filtrados.push([{ text: "Vendedores:", style: "subheader" }, { text: textoFiltrado, style: "textoChico" }]);
  }

  if (values.filtrarProyecto === 1) {
    let textoFiltrado = "";
    values.proyectos.forEach((valueProyecto) => {
      textoFiltrado += `${valueProyecto.nombre}\n`;
    });
    filtrados.push([{ text: "Proyectos:", style: "subheader" }, { text: textoFiltrado, style: "textoChico" }]);
  }

  if (values.filtrarProyecto === 2) {
    filtrados.push([
      { text: "Unidad de Negocio:", style: "subheader" },
      {
        text: `${cuentaMask(
          values.unidadDeNegocio.nivel1 + values.unidadDeNegocio.nivel2 + values.unidadDeNegocio.nivel3 + values.unidadDeNegocio.nivel4 + values.unidadDeNegocio.nivel5
        ) + " - " + values.unidadDeNegocio.nombre}`,
        style: "textoChico",
      },
    ]);
  }

  if (filtrados.length === 0) {
    filtrados.push([{ text: "No tiene filtrados adicionales", style: "subheader" }, { text: "", style: "textoChico" }]);
  }

  const filas = (values.data || []).map((value) => [
    { text: value.folio, style: "textoTabla", alignment: "left" },
    { text: value.fecha, style: "textoTabla", alignment: "center" },
    { text: value.cliente, style: "textoTabla", alignment: "left" },
    { text: value.claveInsumo, style: "textoTabla", alignment: "left" },
    { text: value.descripcionInsumo, style: "textoTabla", alignment: "left" },
    { text: value.cantidad, style: "textoTabla", alignment: "right" },
    { text: value.apartado, style: "textoTabla", alignment: "right" },
    { text: value.pendiente, style: "textoTabla", alignment: "right" },
    { text: value.estado, style: "textoTabla", alignment: "left" },
    { text: value.inventarioDisponible, style: "textoTabla", alignment: "right" },
    { text: value.ocPendiente, style: "textoTabla", alignment: "left" },
    { text: value.faltantePedir, style: "textoTabla", alignment: "right" },
  ]);

  const dd = {
    footer: { image: "logoBiwo", alignment: "center", width: 80 },
    content: [
      {
        style: "tableExample",
        table: {
          widths: ["18%", "52%", "30%"],
          layout: { defaultBorder: false },
          body: [
            [
              ...HeaderEmpresaCard(empresa, false, false, {
                border: [false, false, false, false],
                table: {
                  headerRows: 1,
                  widths: ["100%"],
                  body: [
                    [{ text: "Fecha de Impresión:", style: "subheader", alignment: "center" }],
                    [{ text: moment().locale("es").format("LL"), style: "textoChico", alignment: "center" }],
                  ],
                },
                layout: "noBorders",
              }),
            ],
          ],
        },
      },
      { text: "Pedidos Pendientes De Apartar", style: "tableHeaderIzquierda" },
      { text: "Datos de filtrado:" },
      {
        style: "tableExample",
        table: { widths: ["20%", "80%"], layout: { defaultBorder: false }, body: filtrados },
        layout: {
          hLineWidth: (i, node) => (i === 0 || i === node.table.body.length ? 1 : 1),
          vLineWidth: (i, node) => (i === 0 || i === node.table.widths.length ? 1 : 1),
          hLineColor: () => "#adaaaa",
          vLineColor: () => "#adaaaa",
        },
      },
      {
        style: "tableExample",
        table: {
          widths: ["7%", "6%", "14%", "6%", "15%", "6%", "6%", "6%", "7%", "7%", "11%", "9%"],
          layout: { defaultBorder: true },
          body: [
            [
              { text: "Folio", style: "tituloTabla" },
              { text: "Fecha", style: "tituloTabla" },
              { text: "Cliente", style: "tituloTabla" },
              { text: "Clave", style: "tituloTabla" },
              { text: "Descripción", style: "tituloTabla" },
              { text: "Cantidad", style: "tituloTabla" },
              { text: "Apartado", style: "tituloTabla" },
              { text: "Pendiente", style: "tituloTabla" },
              { text: "Estado", style: "tituloTabla" },
              { text: "Inventario", style: "tituloTabla" },
              { text: "OC Pendiente", style: "tituloTabla" },
              { text: "Falta Pedir", style: "tituloTabla" },
            ],
            ...filas,
          ],
        },
        layout: {
          fillColor: (rowIndex) => (rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff"),
          hLineWidth: (i, node) => (i === 0 || i === node.table.body.length ? 1 : 1),
          vLineWidth: (i, node) => (i === 0 || i === node.table.widths.length ? 1 : 1),
          hLineColor: () => "#adaaaa",
          vLineColor: () => "#adaaaa",
        },
      },
    ],
    images: {
      logo: empresa.logo.base64Completa,
      logoBiwo: logoBiwo.base64Completa,
    },
    styles: {
      tableHeaderIzquierda: { bold: true, fontSize: 18, color: "black" },
      header: { fontSize: 9, bold: true },
      subheader: { fontSize: 8, bold: true },
      tableExample: { margin: [0, 5, 0, 5] },
      tituloTabla: { fontSize: 8, bold: true, fillColor: "#cccccc", style: "subheader", alignment: "center", border: true },
      textoChico: { fontSize: 8 },
      textoTabla: { fontSize: 8, italics: false },
    },
    pageSize: "LETTER",
    pageOrientation: "landscape",
    pageMargins: [20, 20, 20, 60],
  };
  return dd;
};

export default reportePedidosPendientesApartarPdf;
